import classNames from 'classnames'

import Link from '~/components/atoms/Link/Link'

import Button, { ButtonVariants } from '../Button/Button'
import type { ImageProps } from '../Image/Image'
import Image from '../Image/Image'
import Summary from '../Summary/Summary'
import Text, { TextSizes } from '../Text/Text'

import styles from './TeamMemberCard.module.css'

export interface TeamMemberCardProps {
  testID?: string
  name: string
  jobTitle?: string
  email?: string
  slug?: string
  image: ImageProps
  image2?: ImageProps
  description?: any
  listSummary?: string
  useVariant?: boolean
  showSummary?: boolean
  showEmail?: boolean
  showViewProfile?: boolean
  jobTitleBold?: boolean
  summarySmall?: boolean
}

export default function TeamMemberCard({
  testID,
  image,
  image2,
  name,
  slug,
  jobTitle,
  email,
  description,
  listSummary,
  useVariant = false,
  showSummary = false,
  showEmail = true,
  showViewProfile = false,
  jobTitleBold = false,
  summarySmall = false,
}: TeamMemberCardProps) {
  const nameSize = useVariant
    ? TextSizes.magSecondaryTitleSml
    : TextSizes.primaryTitleSml

  const jobSize = useVariant
    ? TextSizes.magBodyLrg
    : TextSizes.secondaryTitleMedReg

  const summary = description ? (
    <Summary modules={description} limit={100} />
  ) : (
    listSummary
  )

  return (
    <div className={styles.base} data-testid={testID}>
      <Link
        href={slug ? `/${slug}` : `/our-people`}
        className={styles.cardLink}
      >
        <>
          <div className={styles.imageContainer}>
            {image && (
              <Image
                {...image}
                objectFit="contain"
                className={styles.image}
                sizes="(max-width: 559px) 100vw, (max-width: 1079px) 33vw, 25vw"
                alt={name}
              />
            )}
            {image2 && (
              <Image
                {...image2}
                objectFit="contain"
                className={styles.image2}
                sizes="(max-width: 559px) 100vw, (max-width: 1079px) 33vw, 25vw"
                alt={name}
              />
            )}
          </div>
          <Text
            Tag="p"
            size={nameSize}
            className={classNames(
              styles.name,
              useVariant && styles.nameVariant
            )}
          >
            {name}
          </Text>
          {jobTitle && (
            <Text
              Tag="p"
              size={jobSize}
              className={classNames(
                styles.jobTitle,
                useVariant && styles.jobTitleVariant,
                {
                  [styles.jobTitleBold]: jobTitleBold,
                }
              )}
            >
              {jobTitle}
            </Text>
          )}
          {showEmail && email && (
            <Text Tag="p" size={TextSizes.bodySml} className={styles.email}>
              {email}
            </Text>
          )}
          {summary && showSummary && (
            <Text
              Tag="p"
              className={classNames(styles.summary, {
                [styles.summarySmall]: summarySmall,
              })}
            >
              {summary}
            </Text>
          )}
          {showViewProfile && (
            <Button
              className={styles.viewProfile}
              variant={ButtonVariants.textLink}
            >
              View Profile
            </Button>
          )}
        </>
      </Link>
    </div>
  )
}
